import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Card, message } from "antd";
import "antd/dist/antd.css";

import _ from "lodash";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";

const { Option } = Select;

export const FaceSearchAllocationForm = (props) => {
  const [form] = Form.useForm();

  const onFormFinish = (values) => {
    
    const requestData = {
      cityId: values.unitName,
      name:
        props.units.find((unit) => unit.cityId === values.unitName)
          ?.city_name[0]?.City || "",
    };

   props.onFormFinish(requestData);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFormFinish}
      initialValues={{
        module_name: "Gang detection tool",
      }}
    >
     

     

      <Form.Item
        label="Select Unit Name"
        name="unitName"
        rules={[{ required: true, message: "Please select your unit!" }]}
      >
        <Select
          placeholder="Please select Unit"
          rules={[{ required: true, message: "Please select Unit" }]}
        >
          {props.units &&
            props.units.length &&
            props.units.map((res) => {
              const isDisabled = props.data.some(
                (item) => item.cityId === res.cityId
              );

              return (
                <Option key={res.id} value={res.cityId} disabled={isDisabled}>
                  {res.city_name[0]?.City}
                </Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          Activate Now
        </Button>
      </Form.Item>
    </Form>
  );
};
